export default {
  appError: '',
  panelBlocked: false,
  //appErrorStatus: 'initial',
  isLoading: false,
  currencyList: [],
  countryList: [], 
  timezoneList: [], 
  alertsCount: 0,
  bookmarks: [],
}
